import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatterySungageApplicationReadDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Saved Sungage application read. Does not call Sungage. The status drawer
 * posts refresh on open for a live check.
 */
export default function useBatterySungageApplication(
  proposalId: string | undefined,
  applicationId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<BatterySungageApplicationReadDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.sungageApplication(
      proposalId ?? ``,
      applicationId ?? ``,
    ),
    queryFn: () => {
      if (!proposalId || !applicationId) {
        throw new Error(`Battery-Only Proposal and application ids are required`)
      }
      return batteryProposalService.getSungageApplication(
        proposalId,
        applicationId,
      )
    },
    enabled: Boolean(proposalId) && Boolean(applicationId) && enabled,
    retry: 1,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
